import api from '../../services/api'

export default {
  namespaced: true,

  state: () => ({
    clients: [],
    selectedClientCode: localStorage.getItem('selectedClientCode') || null,
    loading: false,
    error: null
  }),

  mutations: {
    SET_CLIENTS(state, clients) {
      state.clients = clients
    },
    SET_SELECTED_CLIENT(state, clientCode) {
      state.selectedClientCode = clientCode
      if (clientCode) {
        localStorage.setItem('selectedClientCode', clientCode)
      } else {
        localStorage.removeItem('selectedClientCode')
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },

  actions: {
    async fetchClients({ commit, state }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const response = await api.get('/synergist/clients')
        const clients = response.data.data.clients || []
        commit('SET_CLIENTS', clients)

        // If we have a stored selection, verify it still exists
        if (state.selectedClientCode) {
          const exists = clients.find(c => c.clientCode === state.selectedClientCode)
          if (!exists && clients.length > 0) {
            // Stored client no longer exists, clear selection
            commit('SET_SELECTED_CLIENT', null)
          }
        }

        return clients
      } catch (error) {
        const message = error.response?.data?.error || 'Failed to fetch clients from Synergist'
        commit('SET_ERROR', message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    selectClient({ commit }, clientCode) {
      commit('SET_SELECTED_CLIENT', clientCode)
    }
  },

  getters: {
    allClients: (state) => state.clients,
    selectedClient: (state) => {
      return state.clients.find(c => c.clientCode === state.selectedClientCode)
    },
    selectedClientCode: (state) => state.selectedClientCode,
    // Alias for backwards compatibility with Dashboard watcher
    selectedClientId: (state) => state.selectedClientCode,
    loading: (state) => state.loading,
    error: (state) => state.error
  }
}
